import { route } from '../helpers';

import { PromotionPages } from '../../constants/AppConstants';

export default route(PromotionPages.APPLY_PROMOTION, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/promotion/ApplyPromotion').default);
        }, 'promotion-apply');
    }
});
